import { useStrings } from '@/composables/useStrings.ts'

export function useUnits() {
  const { t } = useStrings()

  function formatTemperature(val: string, showUnit = true) {
    const value = parseFloat(val)
    const unit = showUnit ? '°C' : ''
    return value.toFixed(1) + unit
  }

  function formatWattage(value, displaySign = false, showDecimalForWatts = false) {
    // We only need to add a plus, since negative numbers automaticalliy get a
    // minus sign.
    const sign = displaySign && value > 0 ? '+' : ''
    value = parseFloat(value)

    // We round to 1k above/below 990W.
    if (value > 990 || value < -990) {
      value = (value / 1000).toFixed(1)
      return sign + value + ' ' + t('units.kilowatt')
    }

    if (!showDecimalForWatts) {
      value = Math.round(value)
    }
    return sign + value + t('units.watt')
  }

  function formatKWP(value) {
    value = parseFloat(value)
    if (value > 990 || value < -990) {
      value = (value / 1000).toFixed(1)
      value = (value + '').replace(/\./, ',')
      return `${value} ${t(`units.kilowattPeak`)}`
    }

    value = (value.toFixed(1) + '').replace(/\./, ',')
    return `${value} ${t(`units.wattPeak`)}`
  }

  function formatKWH(value) {
    value = parseFloat(value)
    if (value > 990000 || value < -990000) {
      value = (value / 1000000).toFixed(1)
      value = (value + '').replace(/\./, ',')
      return `${value} ${t(`units.megawattHours`)}`
    }

    if (value > 990 || value < -990) {
      value = (value / 1000).toFixed(1)
      value = (value + '').replace(/\./, ',')
      return `${value} ${t(`units.kilowattHours`)}`
    }

    value = (value.toFixed(1) + '').replace(/\./, ',')
    return `${value} ${t(`units.wattHours`)}`
  }

  function formatPowerPrice(value, unit = 'centPerKilowatt') {
    if (isNaN(parseFloat(value))) {
      return value
    }

    value = (parseFloat(value) * 100).toFixed(2)
    value = (value + '').replace(/\./, ',')

    let unitText = ''
    if (unit) {
      unitText = t(`units.${unit}`)
    }
    return `${value} ${unitText}`
  }

  function formatPercent(value) {
    return Number(value ?? 0).toFixed(0) + '%'
  }

  function roundPrice(price) {
    if (!price) { return '0.00' }
    return price.toFixed(2)
  }

  return {
    formatTemperature,
    formatWattage,
    formatKWH,
    formatKWP,
    formatPowerPrice,
    formatPercent,
    roundPrice,
    t,
  }
}
